import React from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'
import SubmittalList from './SubmittalList'
import SubmittalEditor from './SubmittalEditor'

const SubmittalBuilder = (props) => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path} render={() => <SubmittalList {...props} />} />
      <Route path={`${path}/:id`} render={(routeProps) =>
        <SubmittalEditor submittalId={routeProps.match.params.id} {...props} />
      } />
    </Switch>
  )
}

export default SubmittalBuilder
